import ChesseImg from '../../../../../assests/images/card_chesse.svg';
import CloudImg from '../../../../../assests/images/card_clouds.svg';
import DayLightImg from '../../../../../assests/images/card_light.svg';
import NightLightImg from '../../../../../assests/images/card_light_dark.svg';
import ScrapperImg from '../../../../../assests/images/card_scrapper.svg';
import BrightHappyImg from '../../../../../assests/images/card_bright_happy.svg';
import TressImg from '../../../../../assests/images/card_trees.svg';
import PartyLightImg from '../../../../../assests/images/card_light_party.svg';

export const cardItems = [
  {
    id: 1,
    image: `${ChesseImg}`,
  },
  {
    id: 2,
    image: `${CloudImg}`,
  },
  {
    id: 3,
    image: `${DayLightImg}`,
  },
  {
    id: 4,
    image: `${NightLightImg}`,
  },
  {
    id: 5,
    image: `${ScrapperImg}`,
  },
  {
    id: 6,
    image: `${BrightHappyImg}`,
  },
  {
    id: 7,
    image: `${TressImg}`,
  },
  {
    id: 8,
    image: `${PartyLightImg}`,
  },
];
